import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { createGoalModel } from '@akin-home/goals';
import {
  createGoalMutation,
  goalModelToCreateGraphql,
  goal_query_keys,
} from '@akin-home/goals/frontend';
import { z } from 'zod';
import { createOutputTextItem } from '../../ChatItem/functions';
import { CreateGoalCommand } from '../schemas';

const Params = z.object({
  user_id: z.string(),
  habitatID: z.string(),
  data: CreateGoalCommand.shape.data,
});

type Params = z.infer<typeof Params>;

export const handleCreateGoalCommand = async (params: Params) => {
  const { goal, success_message, error } = createGoalCommand(params);

  const { addChatItem, query_client } = useStateStore.getState();

  if (goal) {
    try {
      await createGoalMutation({
        input: goalModelToCreateGraphql(goal),
      });

      query_client.invalidateQueries(goal_query_keys.lists());

      if (success_message) {
        addChatItem(
          createOutputTextItem(
            success_message || 'Done, I have created that goal for you.'
          )
        );
      }
    } catch (ex) {
      if (params.data.error_message) {
        addChatItem(
          createOutputTextItem(
            params.data.error_message ||
              "Sorry, I couldn't create that goal for you."
          )
        );
      }
    }
  } else if (error && params.data.error_message) {
    addChatItem(
      createOutputTextItem(
        params.data.error_message ||
          "Sorry, I couldn't create that goal for you."
      )
    );
  }
};

export const createGoalCommand = (params: Params) => {
  const result = Params.safeParse(params);

  if (!result.success) {
    return { error: result.error };
  }

  const { data } = result;

  const {
    user_id,
    habitatID,
    data: { success_message, ...goal_data },
  } = data;

  return {
    success_message,
    goal: createGoalModel({
      ...goal_data,
      habitatID: habitatID,
      participant_ids: [user_id],
    }),
  };
};
